import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  Button,
} from '@mui/material';

interface CreateDefaultRulesDialogProps {
  open: boolean;
  company: string;
  center: string;
  onClose: () => void;
  onConfirm: () => void;
}

const CreateDefaultRulesDialog: React.FC<CreateDefaultRulesDialogProps> = ({
  open, company, center, onClose, onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 600 }}>Create Default Staffing Rules</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will initialize staffing rules for <strong>{company} / {center}</strong> with
          9 default department configurations. You can edit them after creation.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            backgroundColor: '#3b82f6',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': { backgroundColor: '#2563eb' },
          }}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateDefaultRulesDialog;
